module.exports = __webpack_public_path__ + "img/skyblueCircle.29a306b0.png";